import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function moveOrganizationUser(id, payload) {
  if (!id || !payload?.organization_id) {
    return {
      success: false,
      message: "이동할 구성원과 조직을 선택해 주세요.",
      data: null,
      code: "INVALID_MOVE_REQUEST",
    };
  }

  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/users/${encodeURIComponent(id)}/organization`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json().catch(() => ({}));

    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
      code: data?.code ?? "",
    };
  } catch (error) {
    console.error("[moveOrganizationUser] failed:", error);
    return {
      success: false,
      message: "구성원의 소속 조직을 이동하지 못했습니다.",
      data: null,
      code: "NETWORK_ERROR",
    };
  }
}
